var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"upload-img-tips"},[_vm._v(_vm._s(_vm.$t('Only_jpg_png_images_can_be_uploaded_and_should_not_exceed_10MB')))])
}
var staticRenderFns = []

export { render, staticRenderFns }